import { useMutation } from '@tanstack/react-query';
import { POST, POST_UPDATE_TRACKING } from '../../../../services';
import { updateTracking } from '../../../../resources/payload';
import { openAlert } from '../../../../components/alert/hooks';

export const useUpdateTracking = ({ onSuccessCallBack }) => {
  return useMutation({
    mutationFn: async (values) => {
      const payload = updateTracking(values);
      const response = await POST(POST_UPDATE_TRACKING(), payload);
      if (onSuccessCallBack) onSuccessCallBack(response);

      return response.result;
    },
    onSuccess: () => {
      openAlert({
        model: 'message',
        type: 'success',
        message: 'แก้ไขเลขพัสดุสำเร็จ',
      });
    },
    onError: (error) => {
      openAlert({
        model: 'message',
        type: 'error',
        message: error?.message,
      });
    },
  });
};
